import {ApiModalForm} from './ApiModalForm'

const ApiModalFormWrapper = ({setOpenAPIModal, getUser, user, setOpenAPIpermissionsModal, setPartnerId}) => {
    return <ApiModalForm
        setOpenAPIModal={setOpenAPIModal}
        getUser={getUser}
        user={user}
        setOpenAPIpermissionsModal={setOpenAPIpermissionsModal}
        setPartnerId={setPartnerId}
    />
}

export {ApiModalFormWrapper}
